import axios from 'axios';
import router from "../../router";

const state = {
    order: null,
    loadingOrder: false,
    items: [],
    itemSum: 0,
    member: {
        DefaultShippingAddress: {
            Country: 'NZ',
            Address: '',
            Suburb: '',
            City: '',
            State: '',
            PostalCode: '',
            Phone: ''
        },
        FirstName: '',
        Surname: ''
    },
    toastProduct: null,
    toastVariation: null,
    shippingCountries: [],
    showToast: false,
    toastTimer: null,
    showCart: false,
    showCheckout: false,
    checkoutStep: 1,
    subtotal: 0,
    discount: 0,
    donation: 0,
    clubDiscount: 0,
    giftNotes: '',
    shippingNotes: '',
    shippingMethod: 'shipping',
    shipping: 0,
    tax: 0,
    total: 0,
    sessionOrder: null,
    checkoutFormError: null
};

const getters = {
    getOrder: () => state.order,
    getLoadingOrder: () => state.loadingOrder,
    getItems: () => state.items,
    getItemSum: () => state.itemSum,
    getMember: () => state.member,
    getToastProduct: () => state.toastProduct,
    getToastVariation: () => state.toastVariation,
    getShowToast: () => state.showToast,
    getShippingCountries: () => state.shippingCountries,
    getShowCart: () => state.showCart,
    getCheckoutStep: () => state.checkoutStep,
    getSubtotal: () => state.subtotal,
    getDiscount: () => state.discount,
    getClubDiscount: () => state.clubDiscount,
    getGiftNotes: () => state.giftNotes,
    getShippingNotes: () => state.shippingNotes,
    getShippingMethod: () => state.shippingMethod,
    getShipping: () => state.shipping,
    getDonation: () => state.donation,
    getTax: () => state.tax,
    getTotal: () => state.total,
    getCheckoutFormError: () => state.checkoutFormError,
    getSessionOrder: () => state.sessionOrder,
};

const actions = {
    async addToCart({dispatch, commit}, link) {
        commit('updateShowToast', false);
        const response = await axios.get(link);
        if (typeof response.data.Product !== 'undefined') {
            response.data.Product.Quantity = (typeof response.data.Quantity !== 'undefined' && response.data.Quantity > 1) ? response.data.Quantity : 1;
            response.data.Product.UnitPrice = (typeof response.data.UnitPrice !== 'undefined' && parseFloat(response.data.UnitPrice) > 0) ? parseFloat(response.data.UnitPrice) : response.data.Product.LocalisedPrice;
            commit('updateToastProduct', response.data.Product);
            if (response.data.Variation) {
                commit('updateToastVariation', response.data.Variation);
            }

            // show the toast for 5 seconds
            commit('updateShowToast', true);
            clearTimeout(state.toastTimer);
            let timer = setTimeout(() => {
                commit('updateShowToast', false);
            }, 5000);
            commit('updateToastTimer', timer);

            // fetch order on a separate async function, it involves recalculating the order which takes time.
            dispatch('fetchOrder');
        }
    },

    async fetchOrder({dispatch, commit}) {
        commit('updateLoadingOrder', true);
        const response = await axios.get(window.location.origin + '/checkout/fetchorder');
        if (typeof response.data !== 'undefined') {
            dispatch('updateCartData', response.data);
            dispatch('updateTotals', response.data);

            if (response.data.Unshippable) {
                commit('updateShippingMethod', 'email');
            }

            commit('updateItemSum', response.data.itemsum);
        }
    },

    async fetchSessionOrder({dispatch, commit}, orderID) {
        const response = await axios.get(window.location.origin + '/checkout/fetchsessionorder?order=' + orderID);
        if (typeof response.data !== 'undefined') {
            commit('updateSessionOrder', response.data);
        }
    },

    async updateOrder({dispatch, commit}, link) {
        const response = await axios.get(link);
        if (typeof response.data !== 'undefined') {
            dispatch('updateTotals', response.data);
        }
    },

    async removeItem({dispatch, commit}, link) {
        const response = await axios.get(link);
        if (typeof response.data !== 'undefined') {
            dispatch('updateCartData', response.data);
            dispatch('updateTotals', response.data);
            commit('updateItemSum', response.data.itemsum);
        }
    },

    async applyCoupon({dispatch, commit}, code) {
        const response = await axios.get(window.location.origin + '/checkout/applyCoupon?Code=' + code);
        if (typeof response.data !== 'undefined') {
            dispatch('updateCartData', response.data);
            dispatch('updateTotals', response.data);
        }
    },

    async fetchMemberData({commit}) {
        const response = await axios.get(window.location.origin + '/account/user');
        if (typeof response.data.member !== 'undefined') {
            commit('updateMember', response.data.member);
        }
    },

    async loginShopUser({dispatch, commit}, data) {
        commit('updateFormError', null);
        const response = await axios.post(window.location.origin + '/account/login', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        commit('updateFormError', response.data.message ? response.data.message : null);
        if (typeof response.data.member !== 'undefined') {
            commit('updateMember', response.data.member);

            dispatch('fetchOrder');
            commit('updateCheckoutStep', 3);
        }
    },

    async saveShipping({dispatch, commit}, data) {
        commit('updateCheckoutFormError', null);
        const response = await axios.post(window.location.origin + '/checkout/shipping', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (typeof response.data.Error !== 'undefined') {
            commit('updateCheckoutFormError', response.data.Error);
        } else if (response.data.Order !== 'undefined') {
            dispatch('updateTotals', response.data.Order)
            commit('updateCheckoutStep', 4);
        }
    },

    async payOrder({dispatch, commit}, data) {
        const response = await axios.post(window.location.origin + '/checkout/process', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (typeof response.data.Redirect !== 'undefined') {
            window.location.replace(response.data.Redirect);
        }
    },

    async applyDonation({dispatch, commit}, data) {
        const response = await axios.post(window.location.origin + '/checkout/donate', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (response.data.Order !== 'undefined') {
            dispatch('updateTotals', response.data.Order);
        }
    },

    async clearDonation({dispatch, commit}) {
        let data = new FormData();
        data.append('Donation', 0);
        const response = await axios.post(window.location.origin + '/checkout/donate', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (response.data.Order !== 'undefined') {
            dispatch('updateTotals', response.data.Order);
        }
    },

    async expressPayOrder({dispatch, commit}, data) {
        const response = await axios.post(window.location.origin + '/checkout/express', data, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (typeof response.data.Redirect !== 'undefined') {
            window.location.replace(response.data.Redirect);
        }
    },

    updateTotals({commit}, order) {
        let items = order.Items,
            modifiers = order.Modifiers,
            member = order.Member;

        if (typeof items !== 'undefined') {
            let subTotal = items.map(item => item.CalculatedTotal).reduce((a, b) => a + b);
            commit('updateSubtotal', subTotal);
        } else {
            commit('updateSubtotal', 0);
        }

        if (typeof modifiers !== 'undefined') {
            let discount = modifiers.find(m => m.Title == 'Discount'),
                discountAmount = typeof discount !== 'undefined' ? discount.Amount : 0;
            commit('updateDiscount', discountAmount);

            let clubDiscount = modifiers.find(m => m.Title == 'Member Discount'),
                clubDiscountAmount = typeof clubDiscount !== 'undefined' ? clubDiscount.Amount : 0;
            commit('updateClubDiscount', clubDiscountAmount);

            let shipping = modifiers.find(m => m.Title == 'Shipping'),
                shippingAmount = typeof shipping !== 'undefined' ? shipping.Amount : 0;
            commit('updateShipping', shippingAmount);

            let donation = modifiers.find(m => m.Title == 'Donation'),
                donationAmount = typeof donation !== 'undefined' ? donation.Amount : 0;
            commit('updateDonation', donationAmount);

            let tax = modifiers.find(m => m.Title.includes('Tax')),
                taxAmount = typeof tax !== 'undefined' ? tax.Amount : 0;
            commit('updateTax', taxAmount);
        } else {
            commit('updateDiscount', 0);
            commit('updateShipping', 0);
            commit('updateTax', 0);
        }

        if (typeof member !== 'undefined' && member.ID > 0) {
            commit('updateMember', member);
        }

        commit('updateTotal', order.Total > 0 ? order.Total : 0);
    },

    updateCartData({commit}, order) {
        commit('updateOrder', order);
        let items = order.Items,
            member = order.Member,
            countries = order.ShippingCountries;

        if (typeof member !== 'undefined') {
            commit('updateMember', member);
        } else {
            commit('updateMember', {
                DefaultShippingAddress: {
                    Country: 'NZ',
                    Address: '',
                    Suburb: '',
                    City: '',
                    State: '',
                    PostalCode: '',
                    Phone: ''
                },
                FirstName: '',
                Surname: ''
            });
        }

        if (typeof items !== 'undefined') {
            commit('updateItems', items);
        } else {
            commit('updateItems', []);
        }

        if (typeof countries !== 'undefined') {
            // countries.unshift({'code': '', 'country': 'Please select a country'});
            commit('updateShippingCountries', countries);
        }

        commit('updateLoadingOrder', false);
    },

    toggleShowCart({commit}) {
        let showing = state.showCart;
        commit('updateShowCart', !showing);
    },

    setCheckoutStep({commit}, step) {
        commit('updateCheckoutStep', step);
    },

    setShowToast({commit}, display) {
        commit('updateShowToast', display);
    },

    setShippingMethod({commit}, shippingMethod) {
        commit('updateShippingMethod', shippingMethod);
    },

    setShippingNotes({commit}, notes) {
        commit('updateShippingNotes', notes);
    },

    setGiftNotes({commit}, notes) {
        commit('updateGiftNotes', notes);
    }
};

const mutations = {
    updateOrder: (state, value) => (state.order = value),
    updateLoadingOrder: (state, value) => (state.loadingOrder = value),
    updateItems: (state, value) => (state.items = value),
    updateItemSum: (state, value) => (state.itemSum = value),
    updateMember: (state, value) => (state.member = value),
    updateToastProduct: (state, value) => (state.toastProduct = value),
    updateToastVariation: (state, value) => (state.toastVariation = value),
    updateShowToast: (state, value) => (state.showToast = value),
    updateToastTimer: (state, value) => (state.toastTimer = value),
    updateShippingCountries: (state, value) => (state.shippingCountries = value),
    updateShowCart: (state, value) => (state.showCart = value),
    updateCheckoutStep: (state, value) => (state.checkoutStep = value),
    updateSubtotal: (state, value) => (state.subtotal = value),
    updateDiscount: (state, value) => (state.discount = value),
    updateGiftNotes: (state, value) => (state.giftNotes = value),
    updateClubDiscount: (state, value) => (state.clubDiscount = value),
    updateShipping: (state, value) => (state.shipping = value),
    updateDonation: (state, value) => (state.donation = value),
    updateTax: (state, value) => (state.tax = value),
    updateTotal: (state, value) => (state.total = value),
    updateShippingMethod: (state, value) => (state.shippingMethod = value),
    updateShippingNotes: (state, value) => (state.shippingNotes = value),
    updateCheckoutFormError: (state, value) => (state.checkoutFormError = value),
    updateSessionOrder: (state, value) => (state.sessionOrder = value),
};

export default {
    state,
    getters,
    actions,
    mutations
};
